export const STORIES = [
  {
    id: "contracting-group",
    name: { ar: "م. خالد الشمري", en: "Eng. Khaled Al-Shammari" },
    role: { ar: "مدير عام مجموعة مقاولات", en: "General Manager of a contracting group" },
    sector: { ar: "قطاع المقاولات", en: "Contracting sector" },
    quote: {
      ar: "يديرون حساباتنا في قوى ومقيم بالكامل؛ رخص العمل والإقامات تُنجز قبل انتهائها بتنبيهات مسبقة. وفّروا علينا موظف شؤون حكومية كامل.",
      en: "They fully manage our Qiwa and Muqeem accounts; work permits and residencies are completed before expiry with early alerts. They saved us an entire government-affairs hire.",
    },
    challenge: {
      ar: "مجموعة مقاولات توظف أكثر من 60 موظفاً، وكانت تعاني من تراكم معاملات قوى ومقيم وغرامات متكررة بسبب انتهاء الإقامات ورخص العمل دون تنبيه.",
      en: "A contracting group with 60+ employees suffered from piled-up Qiwa and Muqeem transactions and repeated fines due to residencies and work permits expiring unnoticed.",
    },
    solution: {
      ar: "تولت برق سيف الإدارة الكاملة لحسابي قوى ومقيم ضمن الباقة الذهبية، مع نظام تنبيهات مبكر قبل كل انتهاء، وتنفيذ دوري مجدول لجميع الرخص والإقامات.",
      en: "Barq Safe took over full management of the Qiwa and Muqeem accounts under the Gold package, with an early-alert system before every expiry and scheduled execution of all permits and residencies.",
    },
    results: {
      ar: [
        { n: "0", l: "غرامة منذ التعاقد" },
        { n: "+40", l: "رخصة وإقامة منجزة" },
        { n: "7 أيام", l: "متوسط إنجاز المعاملة" },
      ],
      en: [
        { n: "0", l: "Fines since signing" },
        { n: "+40", l: "Permits & residencies done" },
        { n: "7 days", l: "Average transaction time" },
      ],
    },
  },
  {
    id: "tech-startup",
    name: { ar: "أ. سارة العتيبي", en: "Ms. Sara Al-Otaibi" },
    role: { ar: "الرئيس التنفيذي لشركة تقنية ناشئة", en: "CEO of a tech startup" },
    sector: { ar: "قطاع التقنية", en: "Technology sector" },
    quote: {
      ar: "سرعة إنجاز غير متوقعة — أنهوا تأسيس شركتنا الناشئة وسجلنا التجاري خلال أيام، وتعاملهم مع المنصات الحكومية احترافي من أول رسالة.",
      en: "Unexpectedly fast execution — they completed our startup formation and commercial registration within days, and their handling of government platforms is professional from the very first message.",
    },
    challenge: {
      ar: "فريق مؤسس منشغل بالكامل بتطوير المنتج، ولا يملك أي خبرة بإجراءات حجز الاسم والسجل التجاري والتسجيل في التأمينات وقوى.",
      en: "A founding team fully occupied with product development, with no experience in name reservation, commercial registration, or GOSI and Qiwa registration procedures.",
    },
    solution: {
      ar: "باقة تأسيس شاملة: حجز الاسم التجاري، إصدار السجل، فتح ملفات التأمينات وقوى وبلدي، ثم الباقة الذهبية السنوية لإدارة كل الملفات الحكومية.",
      en: "A complete formation package: trade name reservation, CR issuance, opening GOSI, Qiwa and Balady files, then the annual Gold package to manage all government files.",
    },
    results: {
      ar: [
        { n: "5 أيام", l: "من التوقيع إلى السجل" },
        { n: "0", l: "زيارة لجهة حكومية" },
        { n: "+10", l: "خدمات مفعّلة في أسبوع" },
      ],
      en: [
        { n: "5 days", l: "From signing to registration" },
        { n: "0", l: "Visits to government entities" },
        { n: "+10", l: "Services activated in a week" },
      ],
    },
  },
  {
    id: "logistics-platform",
    name: { ar: "م. فيصل بن جاسم", en: "Eng. Faisal bin Jassim" },
    role: { ar: "شريك مؤسس في منصة لوجستية", en: "Co-founder of a logistics platform" },
    sector: { ar: "استثمار أجنبي — قطاع الخدمات اللوجستية", en: "Foreign investment — Logistics sector" },
    quote: {
      ar: "من رخصة الاستثمار إلى الحساب البنكي والتأشيرات، مشوا معنا خطوة بخطوة حتى أطلقنا منصتنا اللوجستية. تجربة تأسيس سلسة ومحترفة.",
      en: "From the investment license to the bank account and visas, they walked with us step by step until we launched our logistics platform. A smooth, professional formation experience.",
    },
    challenge: {
      ar: "شركاء أجانب يرغبون بدخول السوق السعودي بمنصة لوجستية، دون أي معرفة بمتطلبات وزارة الاستثمار أو إجراءات التأسيس والحسابات البنكية.",
      en: "Foreign partners wanting to enter the Saudi market with a logistics platform, with no knowledge of MISA requirements or formation and banking procedures.",
    },
    solution: {
      ar: "أصدرنا رخصة وزارة الاستثمار (MISA)، وثقنا عقد التأسيس إلكترونياً، أصدرنا السجل التجاري والعنوان الوطني، ورافقنا الشركاء في فتح الحساب البنكي واستخراج التأشيرات.",
      en: "We issued the MISA license, e-notarized the articles of association, issued the commercial registration and national address, and accompanied the partners through bank account opening and visas.",
    },
    results: {
      ar: [
        { n: "3 أسابيع", l: "من الرخصة إلى التشغيل" },
        { n: "100%", l: "إنجاز عن بُعد" },
        { n: "6", l: "جهات حكومية مُنجزة" },
      ],
      en: [
        { n: "3 weeks", l: "From license to operation" },
        { n: "100%", l: "Done fully remotely" },
        { n: "6", l: "Government entities completed" },
      ],
    },
  },
];
